import { DatePipe } from '@angular/common';
import { Component, computed, inject, input, Signal } from '@angular/core';
import { formatDNI } from '../../../helpers/utils';
import { CuitPipe } from '@webapp/core/pipes/cuit.pipe';
import { IUser, USER_TYPES } from '@webapp/users/interfaces/users.interface';
import { ResumeItemComponent } from '../resume-item/resume-item.component';
import { IResumeItem } from '@webapp/quoter/interfaces/quoter.interface';

@Component({
  selector: 'app-user-resume',
  standalone: true,
  imports: [ResumeItemComponent],
  providers: [DatePipe, CuitPipe],
  templateUrl: './user-resume.component.html',
  styleUrl: './user-resume.component.scss',
})
export class UserResumeComponent {
  user = input.required<IUser>();
  private readonly datePipe = inject(DatePipe);
  private readonly cuitPipe = inject(CuitPipe);

  readonly items: Signal<IResumeItem[]>;

  constructor() {
    this.items = computed(() => {
      const user = this.user();
      if (!user) return [];

      const isPerson = user.type === USER_TYPES.PERSON;
      const name = isPerson
        ? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim()
        : user.companyName ?? '';
      const identification = isPerson
        ? formatDNI(user.identification ?? '') ?? ''
        : this.cuitPipe.transform(user.identification ?? '') ?? '';
      const birthDate = user.birthDate
        ? this.datePipe.transform(user.birthDate, 'dd/MM/yyyy') ?? ''
        : '';

      return [
        { title: isPerson ? 'Nombre' : 'Razón Social', text: name },
        { title: 'Email', text: user.email ?? '' },
        { title: isPerson ? 'DNI' : 'CUIT', text: identification },
        { title: 'Dirección', text: user.address ?? '' },
        { title: 'Código Postal', text: (user.postalCode && user.postalCode !== 'undefined') ? user.postalCode : '' },
        { title: 'Fecha de nacimiento', text: birthDate },
      ];
    });
  }
}
